import { AccessTokenError } from '~/Api/Authentication';
import { Failure, GeneralError } from '~/ApiClient';
import { ApplicationError } from '~/ApplicationError';
var ErrorHandler = /** @class */ (function () {
    function ErrorHandler(logger, accessToken) {
        this.logger = logger;
        this.accessToken = accessToken;
        this.onAuthenticationFailure = null;
    }
    ErrorHandler.prototype.handle = function (error, meta) {
        if (error instanceof Failure) {
            return this.handleApiFailure(error, meta);
        }
        this.logger.logError(error, this.resolveUserInfo(), meta);
        return ApplicationError.generalFailure;
    };
    ErrorHandler.prototype.handleApiFailure = function (failure, meta) {
        if (this.onAuthenticationFailure !== null && failure.hasAnyOf(Object.values(AccessTokenError))) {
            this.onAuthenticationFailure();
            return null;
        }
        if (failure.hasAnyOf(Object.values(GeneralError))) {
            return ApplicationError.connectionFailure;
        }
        var apiError = new Error(Array.from(failure.codes).join(','));
        apiError.name = 'ApiClientErrorResponse';
        this.logger.logError(apiError, { tags: Array.from(failure.codes), meta: meta !== null && meta !== void 0 ? meta : {} });
        return ApplicationError.connectionFailure;
    };
    ErrorHandler.prototype.resolveUserInfo = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return {
            'Impersonated By Email': (_c = (_b = (_a = this.accessToken) === null || _a === void 0 ? void 0 : _a.impersonatedBy) === null || _b === void 0 ? void 0 : _b.email) !== null && _c !== void 0 ? _c : null,
            'Impersonated By User Id': (_f = (_e = (_d = this.accessToken) === null || _d === void 0 ? void 0 : _d.impersonatedBy) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : null,
            email: (_h = (_g = this.accessToken) === null || _g === void 0 ? void 0 : _g.user.email) !== null && _h !== void 0 ? _h : '',
            id: (_k = (_j = this.accessToken) === null || _j === void 0 ? void 0 : _j.user.id) !== null && _k !== void 0 ? _k : '',
        };
    };
    return ErrorHandler;
}());
export { ErrorHandler };
